// extracted by mini-css-extract-plugin
export default {"MainPage":"MainPage_MainPage__FHXKL","fadein":"MainPage_fadein__+fpeE","MainPage__logoutButton":"MainPage_MainPage__logoutButton__kw2MU","spin":"MainPage_spin__Yh7gW"};